import { useHistory } from 'react-router';
import routes from '../components/Routes/routingMap';
import constants from '../modules/procedures/constants';

const useSelectProcedure = () => {
  const history = useHistory();

  const evalRedirect = (selectedProcedure: number) => {
    const routesMap: Record<number, string> = {
      [constants.categories.requests.procedures.bse]:
        routes.student.procedures.categories.scholarships.bse.home,
      [constants.categories.requests.procedures.updatePhoto]:
        routes.student.procedures.categories.requests.updatephoto.procedureinfo,
      [constants.categories.requests.procedures.employabilityCharter]:
        routes.student.procedures.categories.requests.employabilityCharter.info,
      [constants.categories.requests.procedures.removeOfPeriod]:
        routes.student.procedures.categories.requests.retirementperiod
          .procedureinfo,
      [constants.categories.requests.procedures.changeCareerCampusModality]:
        routes.student.procedures.categories.requests.changecareercampusmodality
          .procedureinfo,
      [constants.categories.requests.procedures.issuanceUniversityCard]:
        routes.student.procedures.categories.requests.issuancefuniversitycard
          .procedureinfo,
      [constants.categories.requests.procedures.changeOfStudyOptionModality]:
        routes.student.procedures.categories.requests.changeStudiesOption
          .procedureinfo,
      [constants.categories.requests.procedures.reincorporation]:
        routes.student.procedures.categories.requests.reincorporation.info,
      [constants.categories.requests.procedures.examStragglers]:
        routes.student.procedures.categories.requests.lateExamen.info,
      [constants.categories.requests.procedures.retreatCourse]:
        routes.student.procedures.categories.requests.retreatCourse.info,
      [constants.categories.requests.procedures.pse]:
        routes.student.procedures.categories.requests.pse.info,
      [constants.categories.requests.procedures.rectificationNotes]:
        routes.student.procedures.categories.requests.rectificationOfNotes.info,
      [constants.categories.requests.procedures.fullCycleDiscount]:
        routes.student.procedures.categories.requests.fullCycleDiscount,
      [constants.categories.requests.procedures.graduatedCertificated]:
        routes.student.procedures.categories.requests.GraduatedCertificate.info
    };
    const route = routesMap[selectedProcedure];
    if (route) {
      history.push(route);
      return;
    }
    const certificate = constants.categories.certificates.type1List.find(
      (p) => p.procedureId === selectedProcedure
    );
    if (certificate) {
      history.push(
        routes.student.procedures.categories.certificates.certificatetype01.procedureinfo.replace(
          ':certificatetype01name',
          certificate.url ?? ''
        )
      );
    }
  };

  return { evalRedirect };
};

export default useSelectProcedure;
